import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'tgrid-community-layout',
    imports: [
        RouterOutlet,
    ],
    template: '<router-outlet></router-outlet>',
    styles: `
    :host{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  `,
})
export class CommunityLayoutComponent {

}
